import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@gsa/afp-component-library';

const ContractHeaderReviewDetailsModal = ({
  isOpen,
  closeModal,
  reviewDetailsData,
}) => {
  const dataToUse = reviewDetailsData;

  if (!dataToUse) {
    return null;
  }

  return (
    <Modal
      id="review-details-modal"
      title={<h2>Vendor Location Differences</h2>}
      variant="large"
      className="solicitation-modal"
      onClose={closeModal}
      style={{ zIndex: 9999 }}
      actions={
        <Button
          type="button"
          variant="unstyled"
          onClick={closeModal}
          label="Close"
        />
      }
    >
      <div className="margin-bottom-2">
        <p>
          The following vendor location information differs from the current
          contract:
        </p>
        {dataToUse.length > 1 && (
          <p className="text-italic text-secondary">
            Found {dataToUse.length} location(s) with differences.
          </p>
        )}
      </div>

      <div
        className="review-details-scroll-container"
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          border: '1px solid #d6d6d6',
          borderRadius: '4px',
          padding: '1rem',
        }}
      >
        {dataToUse.map((difference, index) => (
          <div
            key={index}
            className="margin-bottom-3 padding-2 bg-base-lighter"
          >
            <h4 className="margin-top-0 margin-bottom-2">
              Location {index + 1}
            </h4>
            <div className="grid-row grid-gap">
              <div className="grid-col-6">
                <strong>Location Name:</strong>
                <br />
                {difference.associatedLocationName || 'N/A'}
              </div>
              <div className="grid-col-6">
                <strong>Address:</strong>
                <br />
                {difference.address1 || 'N/A'}
              </div>
            </div>
            <div className="grid-row grid-gap margin-top-1">
              <div className="grid-col-4">
                <strong>City:</strong>
                <br />
                {difference.city || 'N/A'}
              </div>
              <div className="grid-col-4">
                <strong>State ID:</strong>
                <br />
                {difference.stateId || 'N/A'}
              </div>
              <div className="grid-col-4">
                <strong>Country ID:</strong>
                <br />
                {difference.countryId || 'N/A'}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

ContractHeaderReviewDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  reviewDetailsData: PropTypes.array,
};

export default ContractHeaderReviewDetailsModal;
